import { useCallback } from "react";
import { useAppDispatch } from "../../../store";
import MailingsService from "../../../services/mailings";
import { setErrorMessage } from "../../../acions/actionsCreators/messageActions";
import { useOpenProgressModal } from "../../../lib/hooks/useOpenProgressModal";
import { EMAILS_WERE_SENT } from "../../../lib/constants";

export const useSendOne = (
  reloadData: () => void,
  setIsSending: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  const dispatch = useAppDispatch();

  const { openModal } = useOpenProgressModal(
    "Sending Email",
    "Sending Email failed",
    reloadData,
    {
      customMsg: EMAILS_WERE_SENT,
    },
  );

  const send = useCallback(
    async (id: string) => {
      try {
        setIsSending(true);

        const taskId: string = await MailingsService.sendOne(id);

        setIsSending(false);

        openModal(taskId);
      } catch (e: any) {
        dispatch(setErrorMessage(e.response.data.title, true));
        setIsSending(false);
      }
    },
    [dispatch, openModal, setIsSending],
  );

  return { send };
};
